import { isArrayEqual } from '../../utils';
import { trackEvent } from '@v7/form/src/utils/mixpanel/mixpanelActions';
import { mixpanelEvents } from '@v7/form/src/utils/mixpanel/mixpanelEvent';

export const setLayoutStateEffect = async (layouts: any, layoutState: any, setLayoutState: any) => {
  if (layouts && !isArrayEqual(layoutState, layouts)) setLayoutState(layouts);
};

export const publishFormState = async (id: string | undefined, publishForm: any, navigate: any) => {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('accessToken');
    await publishForm({ form_id: Number(id) });
    trackEvent(mixpanelEvents.PUBLISH_NEW_FORM);
    navigate(`/renderer/${id}?accessToken=${token}`);
  } catch (err) {
    console.error(err);
  }
};
